/**
 * Normalizes a URL by ensuring it has a protocol (adds https:// if missing).
 * @param url - The URL string to normalize
 * @returns The normalized URL with protocol, or the original if invalid
 *
 * @example
 * normalizeUrl('example.com') // 'https://example.com'
 * normalizeUrl('www.example.com') // 'https://www.example.com'
 * normalizeUrl('https://example.com') // 'https://example.com'
 * normalizeUrl('http://example.com') // 'http://example.com'
 */
export function normalizeUrl(url) {
    const trimmedUrl = url.trim();
    if (!trimmedUrl)
        return trimmedUrl;
    try {
        // Try to parse as-is first (handles URLs that already have a protocol)
        new URL(trimmedUrl);
        return trimmedUrl;
    }
    catch {
        // If parsing fails, assume it needs https:// prefix
        try {
            const urlWithProtocol = `https://${trimmedUrl}`;
            new URL(urlWithProtocol);
            return urlWithProtocol;
        }
        catch {
            // If still invalid, return original (validation will be handled elsewhere)
            return trimmedUrl;
        }
    }
}
//# sourceMappingURL=normalizeUrl.js.map